import { Logo } from "../../../styles/logos/ipg-logo";
import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { PURPOSE } from "./constants";

const styleLoginWrapper = (purpose, isHovering) => {
  const Style = {
    alignItems: "center",
    cursor: "pointer",
    borderRadius: "15px",
    display: "flex",
    height: purpose === PURPOSE.REGISTER ? "200px" : purpose === PURPOSE.RESET_PASSWORD? "160px" : "100px",
    color: "white",
    justifyContent: "center",
    padding: "0px",
    width: "50px",
    backgroundColor: isHovering ? "#0455ceff" : "#0d6efd"
  }
  return Style
}

export const FormWrapper = ({ onSubmit, methods, handleBackClick, children, heading }) => {
  return (
    <form onSubmit={methods.handleSubmit(onSubmit)}>
      <div className="form-screen">
        <p>{heading}</p>
        <div className="input-container">
          <Button type="button" className="back-btn" onClick={handleBackClick}>
            ←
          </Button>
          {children}
          <Button type="submit" className="action-btn">
            ✓
          </Button>
        </div>
      </div>
    </form>
  );
};

export const LoginWrapper = ({ children, purpose, isHovering, setIsHovering }) => {
  return (
    <>

      <div className={`powerbi-page-login`} >
        <div className={`login-container`}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          style={{
            backgroundColor: "#F1F6FE",
            border: "none",
            height: purpose === PURPOSE.RESET_PASSWORD ? "470px" : purpose === PURPOSE.REGISTER ? "570px" : "350px",
            boxShadow: isHovering ? "3px 3px 30px #87b1dbff" : null
          }} >
          <div className="headline"  >
            <div className={"logo-container"} style={{ paddingLeft: "33px", color: "red" }}>
              <Logo />
            </div>
          </div>
          {children}
        </div>
        <div className={`login-wrapper`}>
        </div>

      </div>


    </>
  );
};

export const FormLoginWrapper = ({ text, children, onSubmit, methods, isNewPasswordValid, enableAlert, list, purpose, forgot, forgetPasswordFormStart }) => {
  const refFrom = useRef();
  const [isHovering, setIsHovering] = useState(false);

  const updateUser = (isNewPasswordValid) => {
    if (isNewPasswordValid) {
      refFrom.current.click()
    }
    else {
      enableAlert({ type: "danger", text: "Please check your password, it does not meet the requirements!" });
    }
  }

  const loginButtonClick = () => {
    if (purpose === PURPOSE.REGISTER || purpose === PURPOSE.RESET_PASSWORD) {
      updateUser(isNewPasswordValid)
    }
    else {
      refFrom.current.click()
    }
  }

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)}  >
      <p style={{ display: "flex", justifyContent: "center" }}>{text}</p>
      <div style={{ display: "flex", alignItems: "center", paddingBottom: "10px" }}>
        {children}
        &nbsp;
        <div className="login-button"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          style={styleLoginWrapper(purpose, isHovering)}
          onClick={() => {
            loginButtonClick()
          }}>
          <span className="material-symbols-outlined"> navigate_next </span>
          <button hidden={true} ref={refFrom} type={"submit"} />
        </div>
      </div>
      <div  >
        {list}
      </div>
      
      {!purpose && <span style={{ display: "flex", justifyContent: "center" }}
        hidden={forgot} >
        <div>
          <p className="forget-password-button" style={{ color: "red" }}
            onClick={() => forgetPasswordFormStart()}>Forgot your password?</p>
        </div>
      </span>}

    </form>
  );
};

